import { useWindowIsMobile } from '@liveauctioneers/hammer-ui-core/providers';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { CatalogDetailsZone } from '@/components/CatalogComponent/components/DetailsZone/CatalogDetailsZone';
import { CatalogDetailsZoneMobile } from '@/components/CatalogComponent/components/DetailsZone/CatalogDetailsZoneMobile';

import { HeaderImageCluster } from './HeaderImageCluster/HeaderImageCluster';

type Props = {
    catalogId: number;
    forceIsLive?: boolean;
};

export const CatalogNewBanner = ({ catalogId, forceIsLive = false }: Props) => {
    const isMobile = useWindowIsMobile();

    return (
        <div
            className={cn(
                'mb-0 flex w-full max-w-[1240px] flex-col self-center smMin:w-[calc(100%-40px)] smMin:border-b smMin:border-border-secondary smMin:pb-md',
                'print:overflow-visible'
            )}
            data-testid="catalog-new-banner"
        >
            <div className="flex w-full flex-col gap-sm smMin:flex-row smMin:items-start smMin:gap-md">
                <HeaderImageCluster
                    catalogId={catalogId}
                    className="w-full smMin:w-auto smMin:shrink-0"
                />

                <div className="flex min-w-0 flex-1 flex-col">
                    {isMobile ? (
                        <CatalogDetailsZoneMobile
                            catalogId={catalogId}
                            className="pt-0"
                        />
                    ) : (
                        <CatalogDetailsZone
                            catalogId={catalogId}
                            className="mb-0"
                            forceIsLive={forceIsLive}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};
